import { Alert, Box, Button, CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { QUICK_STUDY_PATHS, quickStep, withoutQuick } from "./quickStudyRun";

/**
 * The quick study's guide above the page while «Δημιουργία και εκτέλεση» is
 * under way: which step it is at, and a way to stop and carry on by hand.
 */
export default function QuickStudyBanner({ isGreek }) {
  const location = useLocation();
  const navigate = useNavigate();
  const step = quickStep(location);
  if (!step) return null;
  const tr = (el, en) => (isGreek ? el : en);
  const stop = () => navigate(withoutQuick(location), { replace: true });
  const text = {
    locate: tr("Γρήγορη μελέτη · βήμα 1 από 3: ορίστε τη θέση της εγκατάστασης στον χάρτη (κλικ ή μεταφορά του δείκτη) και πατήστε «Συνέχεια». Τα υπόλοιπα γίνονται αυτόματα.",
      "Quick study · step 1 of 3: set the site's location on the map (click or drag the marker) and press \"Continue\". The rest is done for you."),
    design: tr("Γρήγορη μελέτη · βήμα 2 από 3: αυτόματος σχεδιασμός και αποθήκευση του ηλεκτρολογικού σχεδίου…",
      "Quick study · step 2 of 3: auto-design and saving the electrical design…"),
    run: tr("Γρήγορη μελέτη · βήμα 3 από 3: εκτέλεση της μελέτης. Τα αποτελέσματα ανοίγουν μόλις ολοκληρωθεί.",
      "Quick study · step 3 of 3: running the study. The results open as soon as it has finished."),
  }[step];
  return (
    <Alert severity="info" data-testid="quick-study-banner" sx={{ mb: 2, borderRadius: 2, alignItems: "center" }}
      icon={step === "locate" ? undefined : <CircularProgress size={18} />}
      action={(
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {step === "locate" ? (
            <Button variant="contained" size="small" data-testid="quick-study-continue"
              onClick={() => navigate(QUICK_STUDY_PATHS.design)}>
              {tr("Συνέχεια", "Continue")}
            </Button>
          ) : null}
          <Button size="small" color="inherit" data-testid="quick-study-stop" onClick={stop}>
            {tr("Διακοπή", "Stop")}
          </Button>
        </Box>
      )}>
      {text}
    </Alert>
  );
}
